/*
  Aura bracelet recommendation engine.
  Pure and deterministic: same answers + same rules always give the same bracelet.
  Rules come from Shopify metaobjects (type aura_intent), so weights are edited in admin, not here.
*/
(function (w) {
  var VERSION = '1.4.0';
  var SACRED = ['5-mukhi-rudraksha', '7-mukhi-rudraksha', 'buddha', 'evil-eye'];
  var NOT_MAIN = ['kamalgatta', 'haldi'];
  var KIND_FACTOR = { goal: 1, problem: 1.25, zodiac: 0.8 };
  var MAX_PICKS = 3;

  function index(rules) {
    var by = {};
    rules.forEach(function (r) { if (r.active !== false) by[r.kind + ':' + r.key] = r; });
    return by;
  }

  function score(answers, rules, catalog) {
    var by = index(rules), s = {}, why = {}, used = [];
    function take(kind, key) {
      var r = by[kind + ':' + key]; if (!r) return;
      used.push(r);
      Object.keys(r.weights || {}).forEach(function (id) {
        if (!catalog[id]) return;
        s[id] = (s[id] || 0) + Number(r.weights[id]) * KIND_FACTOR[kind];
        (why[id] = why[id] || []);
        if (why[id].indexOf(r.label) < 0) why[id].push(r.label);
      });
    }
    (answers.goals || []).slice(0, MAX_PICKS).forEach(function (k) { take('goal', k); });
    (answers.problems || []).slice(0, MAX_PICKS).forEach(function (k) { take('problem', k); });
    if (answers.sign) take('zodiac', answers.sign);
    return { s: s, why: why, used: used };
  }

  function pickStones(sc, needs, lead, sign) {
    var core = [], covered = [], ids = Object.keys(sc.s).filter(function (id) { return SACRED.indexOf(id) < 0; });
    ids.sort(function (a, b) { return sc.s[b] - sc.s[a] || (a < b ? -1 : 1); });
    if (lead) {
      var lw = lead.weights || {}, m = ids.filter(function (id) { return lw[id] && NOT_MAIN.indexOf(id) < 0; }).sort(function (a, b) { return lw[b] - lw[a] || sc.s[b] - sc.s[a]; })[0];
      if (m) { core.push(m); covered = sc.why[m].filter(function (l) { return needs.indexOf(l) > -1; }); }
    }
    while (core.length < 3 && ids.length) {
      var best = null, bestV = -1;
      ids.forEach(function (id) {
        if (core.indexOf(id) > -1) return;
        var fresh = sc.why[id].filter(function (l) { return needs.indexOf(l) > -1 && covered.indexOf(l) < 0; }).length;
        var v = sc.s[id] + fresh * 4;
        if (v > bestV) { bestV = v; best = id; }
      });
      if (!best) break;
      var adds = sc.why[best].filter(function (l) { return needs.indexOf(l) > -1 && covered.indexOf(l) < 0; });
      if (core.length >= 2 && !adds.length && sc.s[best] < 3) break;
      core.push(best); covered = covered.concat(adds);
    }
    var sacred = Object.keys(sc.s).filter(function (id) { return SACRED.indexOf(id) > -1; })
      .sort(function (a, b) { return sc.s[b] - sc.s[a] || (a < b ? -1 : 1); })[0];
    var withSacred = sacred && sc.s[sacred] >= 2.5 ? sacred : null;
    return { core: core, sacred: withSacred, covered: covered };
  }

  /* Layout: main stone forms the base, supports alternate, sacred beads flank the centre (zodiac) slot. Mirrored around the knot. */
  function layout(n, core, sacred, sign) {
    var half = Math.ceil(n / 2), seq = [];
    var pattern = core.length >= 3 ? [core[0], core[1], core[0], core[2]] : core.length === 2 ? [core[0], core[1]] : [core[0]];
    for (var i = 0; i < half; i++) seq.push(pattern[i % pattern.length]);
    var beads = [];
    for (var j = 0; j < n; j++) beads.push(seq[Math.min(j, n - 1 - j)]);
    if (sacred) {
      var c = Math.floor(n / 2);
      var spots = sacred === 'buddha' ? [sign ? c - 1 : c] : [c - 1, c + 1];
      spots.forEach(function (k) { if (k >= 0 && k < n) beads[k] = sacred; });
    }
    return beads;
  }

  function recommend(answers, rules, catalog, n) {
    var sc = score(answers, rules, catalog);
    var needs = sc.used.filter(function (r) { return r.kind !== 'zodiac'; }).map(function (r) { return r.label; });
    var goal = sc.used.filter(function (r) { return r.kind === 'goal'; })[0];
    var p = pickStones(sc, needs, goal, answers.sign);
    if (!p.core.length) return null;
    var stones = p.core.map(function (id, i) { return { id: id, role: i === 0 ? 'main' : 'support', why: sc.why[id] }; });
    if (p.sacred) stones.push({ id: p.sacred, role: 'sacred', why: sc.why[p.sacred] });
    return {
      version: VERSION,
      name: (goal && (goal.short || goal.label.split(' ')[0])) || 'Aura',
      stones: stones,
      beads: layout(n, p.core, p.sacred, answers.sign),
      unmet: needs.filter(function (l) { return p.covered.indexOf(l) < 0 && !(p.sacred && sc.why[p.sacred].indexOf(l) > -1); }),
      answers: answers
    };
  }

  w.AuraReco = { version: VERSION, recommend: recommend, maxPicks: MAX_PICKS };
})(window);
